/* ROVE NEXT Reya labels and mobile card sizing.
   Configuration imagery is intentionally not replaced here. The section configuration assets remain the source of truth. */
(function(){
  function injectStyle(){
    if(document.getElementById('rn-reya-final-selector-style'))return;
    var style=document.createElement('style');style.id='rn-reya-final-selector-style';
    style.textContent=`
html body [id^="rn-hp-reya-"] .rn-reya-product-name{margin:0 0 10px!important;font-size:10.5px!important;line-height:1.2!important;font-weight:700!important;letter-spacing:.17em!important;text-transform:uppercase!important;color:var(--rn-ink55)!important;text-align:inherit!important;}
@media(max-width:900px){
  html body [id^="rn-hp-reya-"] .rc-media{aspect-ratio:16/11!important;max-height:none!important;}
  html body [id^="rn-hp-reya-"] .rc-media img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:50% 66%!important;transform:none!important;}
}
@media(max-width:600px){
  html body [id^="rn-hp-reya-"] .rc-mobile-head .rn-reya-product-name{text-align:center!important;margin-bottom:9px!important;}
  html body [id^="rn-hp-reya-"] .rn-reya-mobile-fabric{width:100%!important;margin:0!important;padding:0!important;}
  html body [id^="rn-hp-reya-"] .rn-reya-mobile-fabric .rc-stephead{margin-bottom:10px!important;}
  html body [id^="rn-hp-reya-"] .rc-feats{position:relative!important;display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;column-gap:24px!important;row-gap:10px!important;margin-top:12px!important;}
  html body [id^="rn-hp-reya-"] .rc-feats::after{content:""!important;position:absolute!important;top:1px!important;bottom:1px!important;left:50%!important;width:1px!important;background:var(--rn-line)!important;transform:translateX(-.5px)!important;pointer-events:none!important;}
  html body [id^="rn-hp-reya-"] .rc-feats li{min-width:0!important;font-size:11.5px!important;line-height:1.3!important;gap:6px!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice{height:auto!important;min-height:0!important;aspect-ratio:auto!important;display:grid!important;grid-template-rows:auto 54px!important;gap:0!important;padding:0!important;overflow:hidden!important;background:#fff!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice .rc-thumb{width:100%!important;height:auto!important;min-height:0!important;max-height:none!important;margin:0!important;padding:0!important;aspect-ratio:1.46/1!important;border-radius:0!important;overflow:hidden!important;background:var(--rnhp-stone)!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice .rc-thumb img{width:100%!important;height:100%!important;display:block!important;object-fit:cover!important;object-position:50% 100%!important;background:transparent!important;transform:none!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice .rc-config-label{height:54px!important;min-height:0!important;max-height:54px!important;padding:5px 6px 6px!important;margin:0!important;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;box-sizing:border-box!important;background:#fff!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice strong{display:block!important;margin:0!important;padding:0!important;font-size:10.5px!important;line-height:1.12!important;font-weight:650!important;white-space:normal!important;}
  html body [id^="rn-hp-reya-"] .rc-configchoice small{display:block!important;margin:2px 0 0!important;padding:0!important;font-size:9.8px!important;line-height:1.05!important;white-space:normal!important;}
}`;
    document.head.appendChild(style);
  }
  function addProductName(root){
    root.querySelectorAll('.rc-mobile-head,.rc-desktop-head').forEach(function(head){
      if(head.querySelector('.rn-reya-product-name'))return;
      var label=document.createElement('div');label.className='rn-reya-product-name';label.textContent='Reya Form Curved Modular Sofa';head.insertBefore(label,head.firstChild);
    });
  }
  function finishCopy(root){var n=root.querySelector('.rc-expand');if(n)n.innerHTML='<strong>Built to evolve.</strong> Start with two pieces. Add two center modules whenever you’re ready.';}

  /* ==========================================================================
     THE CONFIGURATION NAME CARRIES "CURVED".

     Sharon, 25 Aug: "the word curved should be there so it's always
     consistent" and "two piece curved modular sectional — put the curved word
     in everywhere, please."

     sections/rn-hp-reya.liquid HARDCODES "2 Piece Modular Sectional" and
     "4 Piece Modular Sectional" in 21 places: the four configuration cards,
     the two size buttons, the summary title, the CTA aria-label, the gallery
     alt text, and four data-title attributes that the section's own script
     reads when it rewrites the summary on selection.

     NOTE FOR WHOEVER OPENS THAT SECTION NEXT: the block "label" setting in
     templates/index.json is NEVER RENDERED — grep it, there are no references.
     Editing it in the theme editor changes nothing. These strings are the real
     source, and the permanent fix is to put "Curved" into them directly.

     Until then this runs here, alongside finishCopy(), which already rewrites
     homepage Reya copy the same way. data-title is patched too, otherwise the
     summary would revert to "Modular" the moment a card is clicked.
     ========================================================================== */
  function curvedName(root){
    var add=function(s){return (s||'').replace(/(\d\s*Piece)\s+Modular\s+Sectional/g,'$1 Curved Modular Sectional');};
    root.querySelectorAll('.rc-configchoice strong,.rc-size strong,[data-summary-title]').forEach(function(el){
      var t=add(el.textContent); if(t!==el.textContent) el.textContent=t;
    });
    root.querySelectorAll('[aria-label],[data-title],[alt]').forEach(function(el){
      ['aria-label','data-title','alt'].forEach(function(a){
        if(!el.hasAttribute(a))return;
        var v=el.getAttribute(a), t=add(v); if(t!==v) el.setAttribute(a,t);
      });
    });
    /* the section rewrites the summary from data-title on every click, so keep
       watching rather than fixing once */
    var sum=root.querySelector('[data-summary-title]');
    if(sum&&window.MutationObserver&&!sum.dataset.rnCurvedWatch){
      sum.dataset.rnCurvedWatch='1';
      new MutationObserver(function(){
        var t=add(sum.textContent); if(t!==sum.textContent) sum.textContent=t;
      }).observe(sum,{childList:true,characterData:true,subtree:true});
    }
  }

  function arrangeFabric(root){
    var ways=root.querySelector('.rc-ways');
    var step=ways&&ways.closest('.rc-step');
    var media=root.querySelector('.rc-media');
    var grid=media&&media.parentNode;
    var config=root.querySelector('.rc-config');
    var mobileConfig=root.querySelector('.rc-mobile-config');
    if(!step||!media||!grid||!config||!mobileConfig)return;
    var isMobile=window.matchMedia('(max-width:600px)').matches;
    if(isMobile){
      if(step.parentNode!==grid||step.previousElementSibling!==media)grid.insertBefore(step,media.nextSibling);
      step.classList.add('rn-reya-mobile-fabric');
    }else{
      if(step.parentNode!==config||step.previousElementSibling!==mobileConfig)config.insertBefore(step,mobileConfig.nextSibling);
      step.classList.remove('rn-reya-mobile-fabric');
    }
  }
  function bind(root){
    if(!root||root.dataset.rnReyaSelectorFinal==='1')return;
    root.dataset.rnReyaSelectorFinal='1';
    injectStyle();addProductName(root);finishCopy(root);curvedName(root);arrangeFabric(root);
    var mq=window.matchMedia('(max-width:600px)');
    var onChange=function(){arrangeFabric(root);};
    if(mq.addEventListener)mq.addEventListener('change',onChange);else if(mq.addListener)mq.addListener(onChange);
  }
  function run(scope){var base=scope||document;if(base.matches&&base.matches('[id^="rn-hp-reya-"]'))bind(base);if(base.querySelectorAll)base.querySelectorAll('[id^="rn-hp-reya-"]').forEach(bind);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){run(document);},{once:true});else run(document);
  document.addEventListener('shopify:section:load',function(e){run(e.target);});
})();
